module.exports = __webpack_public_path__ + "img/64c4813.svg";